import React, { useEffect, useState } from "react";
import Header from "../CommonComponents/header";
import { MobileHeader } from "../CommonComponents/mobileHeader";
import { Footer } from "../CommonComponents/footer";
import { baseurl } from "../CommonComponents/baseurl";
import { NavLink } from "react-router-dom";

export const NotFoundPage = () => {

  const [category, setCategorys] = useState([]);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await fetch(`${baseurl}/api/category`, {
          method: "GET",
        });

        const data = await response.json();
        if (data.success === "1") {
          setCategorys(data.data);
        } else {
          console.error("Failed to fetch blog data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategory();
  }, []);

  return (
    <>
      <Header />
      <MobileHeader />
      <div className="desktop_header_spacer"></div>

      <section className="blog_hero_section">
        <NavLink to={"/"}>
        <div className="inner_notfound_blog_hero_section">
          <img
            src="/assets/images/notfoundbanner.png"
            alt="loading"
            height={"100%"}
            width={"100%"}
            style={{ objectFit: "" }}
          />

          <button className="notFound_button">Back to Home</button>
        </div>
        </NavLink>
      </section>

      <section className="notfound_page_tags">
        <div className="left_notfound_page_tags">
          <h1 style={{ textTransform: "uppercase" }}>
            Wide Range of Tube Flex India Windows & Doors
          </h1>
          <p style={{textAlign:'justify'}}>
            "Discover Tube Flex India's wide range of windows and doors, designed to
            elevate Faridabad homes. From sleek aluminium frames to durable uPVC
            and robust solid panel doors, we offer solutions for every style and
            need. Our products blend aesthetic appeal with practical
            functionality, ensuring your home is both beautiful and secure.
            Crafted for Faridabad's climate, Tube Flex India's windows and doors
            provide lasting protection and energy efficiency. Enhance your
            living space with our premium selection, tailored to meet your
            unique requirements. Experience the perfect combination of quality
            and design with Tube Flex India."
          </p>

          <div style={{ display: "flex", gap: "1.2rem" }}>
            {category.map((items) => {
              return (
                <div>
                  <a
                    href={`/${items.slug}`}
                    style={{
                      width: "100%",
                      padding: "0",
                      textTransform: "capitalize",
                      textDecoration: "none",
                    }}
                    key={items.id}
                  >
                    <div
                      style={{
                        textTransform: "capitalize",
                        marginTop: "5px",
                      }}
                    >
                      <button
                        className="header_button1"
                        dangerouslySetInnerHTML={{ __html: items.title }}
                      ></button>
                      {/* {items.title} */}
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>

        <div className="right_notfound_page_tags">
          <img
            src="/assets/images/AboutUs/about_hero_banner.jpg"
            alt="loading"
            height={"100%"}
            width={"100%"}
          />
        </div>
      </section>

      <Footer/>
    </>
  );
};







